export default __webpack_public_path__ + "static/media/AE18.154e5d46.jpg";